import React, {useEffect, useState, useCallback, useContext} from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import {Button} from "react-bootstrap";
import {BaseUrl} from "../../../contexts/baseUrl/baseUrl";

const CreditLimitLedger = ({
                        getLedger,
                        pendingListing,
                        match,
                        history
                    }) => {


    const [listData, setListData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const {baseUrl} = useContext(BaseUrl);

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            getLedger(1)
            setIsLoading(false)
        })()
    }, []);
    const headers = [
        'Action Performed',
        'Credit',
        'Debit',
        'Balance',
        'MRF ID',
        'Challan ID',
        'Invoice ID',
        'Created On'
    ];

    useEffect(() => {
        if (pendingListing && pendingListing?.data && pendingListing?.data.length > 0) {
            const tableData = ['action', 'credit', 'debit', 'balance', 'mrf_id', 'challan_id', 'inv_id', 'created_at'];
            // const action = [{name: 'View Material', link: '/dashboard/view-mrf/' + match.params.list_type}];
            const data = pendingListing?.data.map((element) =>
                Object.assign(
                    ...tableData.map((key) => ({ [key]: element[key] }
                )
            )));
            if (data) {
                data && setListData(data);
            }
            setPageCount(Math.ceil(pendingListing.total / pendingListing.per_page));
        }
    }, [pendingListing])

    const onPageChange = async (val) => {
        setIsLoading(true);
        await getLedger(val.selected + 1);
        // let filter = filterData === null ? null : filterData;
        setIsLoading(false);
    };

    const mrfCreate = () => {
        history.push(`${baseUrl}/mrf`);
    }

    const headerBtns = () => {
        return (
            <>
                {match.params.list_type === '2' &&
                    <Button
                        onClick={mrfCreate}
                        className="filter-hamburger btn btn-transparent filter-btn-dir filters_direction filters-section"
                    >
                        <b className="site_filters" style={{width: "max-content"}}>
                            {localization.materialAcquisition}
                        </b>
                    </Button>
                }
            </>
        );
    };
    return (
        <Layout
            title={localization.creditLimitLedger}
            isLoading={isLoading}
            isGoback={true}
            Buttons={headerBtns}
        >
            <TableSection
                data={listData}
                isId={false}
                isMngId={false}
                headers={headers}
                pageCount={pageCount}
                onPageChange={onPageChange}
                detailList={pendingListing && pendingListing.data}
                srNo={pendingListing?.from}
            />
        </Layout>
    )
}

export default CreditLimitLedger